module.exports = __webpack_public_path__ + "static/img/hot.5012fc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sidebar/hot.png
// module id = 6YDk
// module chunks = 39